import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { usePedidoAlarme } from '../../context/PedidoAlarmeContext';

// ── Ícones simples SVG inline ────────────────────────────────
export const Icon = ({ name, size = 18 }) => {
  const icons = {
    dashboard:  <><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></>,
    building:   <><path d="M3 21V7l9-4 9 4v14"/><path d="M9 21V11h6v10"/></>,
    tag:        <><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><circle cx="7" cy="7" r="1.5"/></>,
    package:    <><path d="M16.5 9.4l-9-5.19"/><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 002 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></>,
    orders:     <><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><line x1="9" y1="12" x2="15" y2="12"/><line x1="9" y1="16" x2="13" y2="16"/></>,
    users:      <><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></>,
    chart:      <><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></>,
    logout:     <><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></>,
    plus:       <><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>,
    edit:       <><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></>,
    trash:      <><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></>,
    search:     <><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></>,
    close:      <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>,
    check:      <><polyline points="20 6 9 17 4 12"/></>,
    cart:       <><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></>,
    eye:        <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>,
    store:      <><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>,
    star:       <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    menu:       <><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></>,
    arrow_left: <><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></>,
    refresh:    <><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></>,
    image:      <><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></>,
    list:       <><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></>,
    settings:   <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></>,
    clock:      <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {icons[name] || null}
    </svg>
  );
};

// ── Alarme de pedido pendente ────────────────────────────────
function AlarmePedidosBanner() {
  const alarme = usePedidoAlarme();
  if (!alarme || alarme.totalPendentes === 0) return null;

  return (
    <div style={{
      margin: '0 16px 14px', padding: '10px 12px', borderRadius: 10,
      background: alarme.tocando ? '#ef4444' : 'rgba(239,68,68,.12)',
      color: alarme.tocando ? '#fff' : '#ef4444',
      display: 'flex', flexDirection: 'column', gap: 6,
      animation: alarme.tocando ? 'pulseAlarme 1s ease-in-out infinite' : 'none',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '.82rem', fontWeight: 800 }}>
        <span style={{ fontSize: '1.05rem' }}>{alarme.tocando ? '🔔' : '🔕'}</span>
        {alarme.totalPendentes} pedido{alarme.totalPendentes > 1 ? 's' : ''} pendente{alarme.totalPendentes > 1 ? 's' : ''}
      </div>
      {alarme.tocando && (
        <button onClick={alarme.silenciar} style={{
          background: 'rgba(255,255,255,.25)', border: 'none', borderRadius: 8,
          color: '#fff', padding: '5px 8px', fontSize: '.72rem', fontWeight: 700,
          cursor: 'pointer', fontFamily: 'inherit',
        }}>
          🔕 Silenciar
        </button>
      )}
    </div>
  );
}

// ── Sidebar Admin ────────────────────────────────────────────
export function AdminSidebar({ perfil }) {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();

  const menuMaster = [
    { label: 'Dashboard', icon: 'dashboard', to: '/master' },
    { label: 'Empresas',  icon: 'building',  to: '/master/empresas' },
    { label: 'Pedidos',   icon: 'orders',    to: '/master/pedidos' },
    { label: 'Usuários',  icon: 'users',     to: '/master/usuarios' },
    { label: 'Logs de Acesso', icon: 'clock', to: '/master/logs-acesso' },
    { label: 'API / ERP', icon: 'list',      to: '/master/api-docs' },
  ];
  const menuEmpresa = [
    { label: 'Dashboard',    icon: 'dashboard', to: '/admin' },
    { label: 'Pedidos',      icon: 'orders',    to: '/admin/pedidos' },
    { label: 'Produtos',     icon: 'package',   to: '/admin/produtos' },
    { label: 'Categorias',   icon: 'tag',       to: '/admin/categorias' },
    { label: 'Clientes',     icon: 'users',     to: '/admin/clientes' },
    { label: 'Relatórios',   icon: 'chart',     to: '/admin/relatorios' },
    { label: 'Configurações', icon: 'settings', to: '/admin/configuracoes' },
  ];
  const menu = perfil === 'master' ? menuMaster : menuEmpresa;

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <h2>🍽 ArautoFood</h2>
        <span>{perfil === 'master' ? 'Admin Master' : usuario?.empresa}</span>
      </div>
      {perfil === 'admin_empresa' && <AlarmePedidosBanner />}
      <nav>
        {menu.map(item => (
          <NavLink key={item.to} to={item.to} end={item.to === '/master' || item.to === '/admin'}
            className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            <Icon name={item.icon} />
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div className="user-name">{usuario?.nome}</div>
        <div style={{ fontSize: '.75rem', marginBottom: '6px' }}>{usuario?.email}</div>
        <button className="logout-btn" onClick={() => { logout(); navigate('/login'); }}>
          Sair
        </button>
      </div>
    </aside>
  );
}

// ── Modal ────────────────────────────────────────────────────
export function Modal({ open, onClose, title, children, size = '' }) {
  if (!open) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal ${size}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="close-btn" onClick={onClose}><Icon name="close" /></button>
        </div>
        {children}
      </div>
    </div>
  );
}

// ── Badge de status pedido ───────────────────────────────────
export function StatusBadge({ status }) {
  const labels = {
    pendente: 'Pendente', aceito: 'Aceito', em_rota: 'Em Rota',
    entregue: 'Entregue', retirado: 'Retirado', cancelado: 'Cancelado',
    ativa: 'Ativa', inativa: 'Inativa', bloqueada: 'Bloqueada',
    ativo: 'Ativo',
  };
  return <span className={`badge status-${status}`}>{labels[status] || status}</span>;
}

// ── Paginação ────────────────────────────────────────────────
export function Pagination({ page, total, limit, onChange }) {
  const pages = Math.ceil(total / limit);
  if (pages <= 1) return null;

  const delta = 2;
  const start = Math.max(1, Math.min(page - delta, pages - delta * 2));
  const end   = Math.min(pages, Math.max(page + delta, delta * 2 + 1));
  const nums  = Array.from({ length: end - start + 1 }, (_, i) => start + i);

  return (
    <div className="pagination">
      <button className="page-btn" onClick={() => onChange(1)} disabled={page <= 1} title="Primeira página">«</button>
      <button className="page-btn" onClick={() => onChange(page - 1)} disabled={page <= 1} title="Página anterior">‹</button>
      {start > 1 && <span className="page-btn" style={{ cursor: 'default' }}>…</span>}
      {nums.map(p => (
        <button key={p} className={`page-btn${page === p ? ' active' : ''}`} onClick={() => onChange(p)}>{p}</button>
      ))}
      {end < pages && <span className="page-btn" style={{ cursor: 'default' }}>…</span>}
      <button className="page-btn" onClick={() => onChange(page + 1)} disabled={page >= pages} title="Próxima página">›</button>
      <button className="page-btn" onClick={() => onChange(pages)} disabled={page >= pages} title="Última página">»</button>
    </div>
  );
}

// ── Formatar moeda ───────────────────────────────────────────
export const formatBRL = (v) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

// ── Formatar data ────────────────────────────────────────────
export const formatDate = (d, tz = 'America/Sao_Paulo') =>
  d ? new Date(d).toLocaleString('pt-BR', { timeZone: tz }) : '-';
